import React from 'react';

interface StepperHeaderProps {
  steps: string[];
  activeStep: number;
}

const StepperHeader: React.FC<StepperHeaderProps> = ({ steps, activeStep }) => {
  const stepCount = steps.length;

  return (
    <div className="px-10 py-6 border-b border-gray-100">
      <div className="relative grid" style={{ gridTemplateColumns: `repeat(${stepCount}, 1fr)` }}>
        {/* Base line */}
        <div
          className="absolute bg-gray-300"
          style={{
            top: '6px',
            left: `calc(100% / ${stepCount} / 2)`,
            right: `calc(100% / ${stepCount} / 2)`,
            height: '2px',
          }}
        />

        {/* Active progress line */}
        <div
          className="absolute bg-green-500 transition-all duration-300"
          style={{
            top: '6px',
            left: `calc(100% / ${stepCount} / 2)`,
            height: '2px',
            width: activeStep === 0 ? '0%' : `calc(${activeStep} * (100% - (100% / ${stepCount})) / ${stepCount - 1})`,
          }}
        />

        {/* Steps */}
        {steps.map((label, index) => {
          const isActive = index === activeStep;
          const isCompleted = index < activeStep;

          return (
            <div key={index} className="flex flex-col items-center relative z-10">
              <div className={`w-3 h-3 rounded-full ${isActive || isCompleted ? 'bg-green-500' : 'bg-gray-300'}`} />
              <span className={`mt-2 text-xs font-medium whitespace-nowrap ${isActive ? 'text-green-600' : 'text-gray-400'}`}>{label}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default StepperHeader;
